import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";

const DEMO = [["admin@demo.fr", "Admin123!", "Administrateur"], ["concepteur@demo.fr", "Concepteur123!", "Concepteur"],
  ["evaluateur@demo.fr", "Evaluateur123!", "Évaluateur"], ["lecteur@demo.fr", "Lecteur123!", "Lecteur"]];

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background text-foreground">
      <div className="hidden lg:flex flex-col justify-between p-12 border-r grid-bg relative overflow-hidden">
        <div className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>AgentOps</div>
        <div className="space-y-6 max-w-lg">
          <h1 className="text-5xl font-bold tracking-tight leading-[1.05]">Orchestrez vos chatbots et callbots IA multi-agents.</h1>
          <p className="text-muted-foreground">Agents versionnés, routage intelligent, RAG documentaire, outils API, studio de test texte et voix, suivi qualité.</p>
        </div>
        <div className="absolute -right-32 -bottom-32 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
        <div className="text-xs text-muted-foreground">Interface d'administration · v1</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5 fade-in" data-testid="login-form">
          <div>
            <h2 className="text-3xl font-bold">Connexion</h2>
            <p className="text-sm text-muted-foreground mt-1">Accédez à la console d'administration.</p>
          </div>
          <Field label="Email"><Input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required /></Field>
          <Field label="Mot de passe"><Input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required /></Field>
          {error && <div className="text-sm text-rose-400" data-testid="login-error">{error}</div>}
          <Button type="submit" className="w-full" disabled={busy} data-testid="login-submit-button">{busy ? "Connexion…" : "Se connecter"}</Button>
          <div className="border rounded-lg p-3 space-y-1.5">
            <div className="text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">Comptes de démonstration</div>
            {DEMO.map(([e, p, r]) => (
              <button type="button" key={e} data-testid={`demo-login-${r}`} onClick={() => { setEmail(e); setPassword(p); }}
                className="w-full flex justify-between text-xs px-2 py-1.5 rounded hover:bg-muted transition-colors">
                <span className="mono">{e}</span><span className="text-muted-foreground">{r}</span>
              </button>
            ))}
          </div>
        </form>
      </div>
    </div>
  );
}
